
export default {
  props:{
    openDialog:{
      type: Boolean,
      default:  function () {
        return false;
      }},
    message: {type: String, default: ""},
    onClose: {
      type: Function,
      required: true,
    },
  },
  methods:{
    handleClose(){
      this.onClose()
    }
  }
}
